import {UNIT_PRICE_TYPES} from '../../utils/upselling';

const UNIT_PRICE_LABELS = {
  [UNIT_PRICE_TYPES.unit]: 'unit_lowercase',
  [UNIT_PRICE_TYPES.day]: 'day_lowercase',
  [UNIT_PRICE_TYPES.person]: 'person_lowercase',
  [UNIT_PRICE_TYPES.group]: 'group_lowercase',
};

const QUANTITY_LABELS = {
  [UNIT_PRICE_TYPES.unit]: 'quantity',
  [UNIT_PRICE_TYPES.person]: 'number_of_people',
  [UNIT_PRICE_TYPES.group]: 'number_of_groups',
  [UNIT_PRICE_TYPES.day]: 'number_of_days',
};

export {UNIT_PRICE_LABELS, QUANTITY_LABELS};
